import React, { useCallback, useEffect, useState } from 'react'
import { DefaultLayout } from '../../layouts'
import { Container, Breadcrumb, SimplePageHeader, StatusHandler, /* ButtonBookmark */ } from '../../components'
import { useDispatch, useSelector } from 'react-redux'
import { fetchProgram } from '../../features/program/slice'
import { fetchBlog } from '../../features/blog/slice'
import { ProgramStoryContent } from './program-story-content'
// import auth from '../../utils/auth'

const ProgramStory = ({ match }) => {
  // const { isOfficial, isVerified } = auth()
  // const bookmarkable = isOfficial || isVerified
  // const [bookmarked, setBookmarked] = React.useState(false)

  const dispatch = useDispatch()
  const programId = match.params.id
  const language = useSelector(state => state.system.language)
  const program = useSelector(state => state.program.data)
  const programStatus = useSelector(state => state.program.status)
  const blog = useSelector(state => state.blog.data)
  const blogStatus = useSelector(state => state.blog.status)
  const blogError = useSelector(state => state.blog.error)
  const [story, setStory] = useState({
    id: false,
    title: {
      en: 'Title',
      id: 'Judul'
    },
    content: {
      en: 'Content',
      id: 'Konten'
    }
  })
  const [organization, setOrganization] = useState({
    name: 'test',
    image: undefined
  })

  const programTitle = program.title[language.name]
  const { title, content } = story

  useEffect(() => {
    if(blogStatus === 'succeeded'){
      if(story.id !== blog.id){
        setStory(blog)
      }
    }
  }, [blog, blogStatus, story])

  const blogFetcher = useCallback((id) => {
    if(id){
      dispatch(fetchBlog(id))
    }
  }, [dispatch])

  // 1. Fetch program
  useEffect(() => {
    if(programStatus === 'idle' && programId){
      dispatch(fetchProgram(programId))
    }
  }, [dispatch, programStatus, programId])

  // 2. Get blog id from program
  useEffect(() => {
    if(program.stories && program.stories[0]){
      const story = program.stories[0]
      if(story.id){
        blogFetcher(story.id)
      } else {
        console.log('story id undefined')
      }
    }

    if(program.organization){
      setOrganization({
        name: program.organization,
        image: program.organization_logo
      })
    }
  }, [program, blogFetcher])

  const routes = [
    {
      name: 'Home',
      route: '/'
    },
    {
      name: 'Program',
      route: '/program'
    },
    {
      name: programTitle,
      route: `/program/${programId}/detail`
    }
  ]

  return (
    <DefaultLayout>
      <SimplePageHeader noPadding/>
      <Container className="py-5 pb-10 lg:py-20 lg:pb-20" color="#f5f5f5">
        <div className="lg:w-8/12 mx-auto">
          <Breadcrumb className="mb-1 lg:mb-5" routes={routes} />

          <StatusHandler
            status={blogStatus}
            error={blogError}
            onRetry={() => dispatch(fetchBlog(story.id))}
          >
            <ProgramStoryContent
              organizationName={organization.name}
              organizationImage={organization.image}
              title={title[language.name]}
              content={content[language.name]}
            />
          </StatusHandler>
        </div>
      </Container>
    </DefaultLayout>
  )
}

export { ProgramStory }
